module.exports = {"440282001":"雄州街道","440282100":"乌迳镇","440282103":"界址镇","440282104":"坪田镇","440282105":"黄坑镇","440282106":"邓坊镇","440282107":"油山镇","440282109":"南亩镇","440282110":"水口镇","440282111":"江头镇","440282112":"湖口镇","440282113":"珠玑镇","440282115":"主田镇","440282116":"古市镇","440282118":"全安镇","440282120":"百顺镇","440282121":"澜河镇","440282122":"帽子峰镇","440282400":"东莞大岭山（南雄）产业转移工业园"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440282.json
// module id = 2091
// module chunks = 0